document.addEventListener("DOMContentLoaded", () => {
  const WISHLIST_KEY = "shopify_wishlist";

  const getWishlist = () => {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  };

  const saveWishlist = (list) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistCount();
  };

  const toggleWishlist = (handle) => {
    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
    updateWishlistButtons();
  };

  const updateWishlistButtons = () => {
    const wishlist = getWishlist();
    document.querySelectorAll("[data-wishlist-toggle]").forEach(btn => {
      const handle = btn.dataset.wishlistToggle;
      btn.classList.toggle("active", wishlist.includes(handle));
    });
  };

  const updateWishlistCount = () => {
    const count = getWishlist().length;
    const counter = document.querySelector(".wishlist-count");
    if (counter) counter.textContent = count;
  };

  document.body.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-wishlist-toggle]");
  if (!btn) return;

  e.preventDefault();
  toggleWishlist(btn.dataset.wishlistToggle);
  showWishlistPopup(btn);
});

  updateWishlistButtons();
  updateWishlistCount();

  const showWishlistPopup = (btn) => {
  const notification = document.querySelector("cart-notification");
  if (!notification) return;

  const image = btn.dataset.wishlistImage;
  const title = btn.dataset.wishlistTitle;
  const price = btn.dataset.wishlistPrice;

  const html = `
    <div class="cart-notification-product">
      <div class="cart-notification-product__image">
        <img src="${image}" alt="${title}" width="70">
      </div>
      <div>
        <p class="cart-notification-product__name">
          Added to wishlist
        </p>
        <p class="cart-notification-product__title">${title}</p>
        <p class="cart-notification-product__price">${price}</p>
      </div>
    </div>
  `;

  notification.querySelector(".cart-notification__product").innerHTML = html;
  notification.querySelector(".cart-notification__header h2").textContent =
    "Wishlist updated";

  notification.open();
};

});
